export interface IVoiceServers {
    sessionId: string;
    isSuccess: boolean;
    data: IVoiceServerData[];
}

export interface IVoiceServerData {
    server: string;
}

export const DefaultVoiceServer: IVoiceServers = {
    sessionId: '',
    isSuccess: false,
    data: [],
};
